import { Dispatch, SetStateAction } from "react";

const overlayHTML = `  
  <div class="overlay-ad-reward absolute right-4 bottom-12 w-max bg-blue-600 z-20 text-white cursor-pointer space-x-2 rounded-md text-sm border-gray-300">
    <a class="z-20 h-8 flex justify-center items-center px-4" href="{{HREF}}">{{TITLE}}</a>
    <div class="absolute z-[-999] w-full right-0 bottom-[-0.25rem] animate-pingShortReduced h-10 bg-blue-700 rounded-md"></div>
  <div>
`;

const buildOverlayHTML = (title: string, href: string) => {
  return overlayHTML.replace("{{TITLE}}", title)
    .replace("{{HREF}}", href);
}

export const createOverlayAdReward = (index: number, playerRef: any, setState?: Dispatch<SetStateAction<number>>, params?: { title: string; href: string }) => {
  const div = document.createElement("div");
  if (!params || !params.title || !params.href) {
    return div;
  }
  div.innerHTML = buildOverlayHTML(params.title, params.href);
  div.onclick = () => {
    if (setState) {
      setState(index);
    }
    // div.innerHTML = "";
    playerRef.pause();
    document.getElementById("adRewardModalBtn")?.click();
  };
  return div;
}
